import {fromJS} from 'immutable';
import {combineReducers} from 'redux-immutable';

import {reducer as questionsReducer} from '../questions';
import {reducer as markersReducer} from '../markers';
import {initialState as markersInitialState} from '../markers';
import treeReducer from '../tree/reducer';
import Examination from './component';
import mainReducer, {layoutReducer} from './reducer';


export const initialState = {elementId: 'examination'};

const _reducer = combineReducers({
    main: mainReducer,
    layout: layoutReducer,
    questions: questionsReducer,
    markers: markersReducer,
    typesTree: treeReducer,
    gradesTree: treeReducer,
    paperTypesTree: treeReducer,
    difficultyLevelsTree: treeReducer,
    questionDialog: combineReducers({
        materialsTree: treeReducer,
        subjectsTree: treeReducer,
        labelsTree: treeReducer,
        typesTree: treeReducer,
        questionLevelsTree: treeReducer,
        statusesTree: treeReducer,
        levelsTree: treeReducer,
        gradesTree: treeReducer,
    }),
});
export const reducer = (state, action) => {
    if (!state.get('layout')) {
        const id = state.get('elementId');
        state = fromJS({
            main: {elementId: id},
            layout: {
                elementId: id + ':layout',
            },
            questions: {elementId: id + ':questions'},
            markers: markersInitialState,
        });
    }
    state = _reducer(state, action);
    return state;
};

export const component = Examination;
